import React from 'react';
import Link from 'next/link';
import { ShoppingCarIcon, formatCurrency } from '@avila-tek/ui/src';
import { Company, Product } from '../../../models';
import { VariantOptions } from '../../shared';
import fallbackImg from '../../../public/images/product-card-fallback.png';

interface ProductCardProps {
  product: Product;
}

function ProductCard({ product }: ProductCardProps) {
  const [selectedVariant, setSelectedVariant] = React.useState(
    product?.variants[0]
  );

  React.useEffect(() => {
    setSelectedVariant(product?.variants[0]);
  }, [product]);

  return (
    <div className="p-5 cursor-pointer">
      <div className="w-56  bg-system-100 rounded-lg drop-shadow hover:shadow-lg transition-all duration-500">
        <Link
          href={`/app/catalogue/${product?.slug}?variant=${selectedVariant?._id}`}
        >
          <div className="h-48">
            <img
              src={
                selectedVariant?.photos?.length > 0
                  ? selectedVariant.photos[0]?.src
                  : fallbackImg.src
              }
              alt="product"
              className="w-full h-full object-fill rounded-tr-lg rounded-tl-lg"
            />
          </div>
        </Link>
        <div className=" p-4 flex justify-between items-center w-full ">
          <div className="flex flex-col w-full space-y-[2px]">
            <Link
              className="flex flex-col w-full space-y-[2px]"
              href={`/app/catalogue/${product?.slug}?variant=${selectedVariant?._id}`}
            >
              <span className="text-purple-300 font-semibold ">
                {product.title}
              </span>
              <span className="text-neutral-cold-500 ">
                {(product.company as Company)?.name}
              </span>
            </Link>
            <div className="w-full flex flex-col gap-2  py-2 ">
              <VariantOptions
                product={product}
                selectedVariant={selectedVariant}
                setSelectedVariant={setSelectedVariant}
              />
            </div>
            <div className="text-neutral-cold-800 font-semibold flex ">
              <div className="w-full flex mx-auto gap-2 items-center ">
                <span className="text-purple-300 text-lg font-extrabold">
                  ${formatCurrency(selectedVariant?.price)}
                </span>
                {selectedVariant?.compareAtPrice && (
                  <span className="text-neutral-cold-400 line-through">
                    ${formatCurrency(selectedVariant?.compareAtPrice)}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div />
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
